import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=87a630a0&scoped=true&"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js&"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSignIn.vue?vue&type=style&index=0&id=87a630a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a630a0",
  null
  
)

export default component.exports